//
//
//
//
//

export default {
	props: {
		show: {
			type: Boolean,
			default: false
		},
	},
	data() {
		return {
			hidden:false
		};
	},
	watch: {
		show(val) {
			if(!val){
				// setTimeout(()=>{
					this.hidden = false
				// },300)
			} else {
				this.hidden = true
			}
		}
	},
	methods: {
		cancel() {
			this.$emit('cancel')
		}
	},
}
